import { FormCollapse, useScopedSelector } from 'ia-react-core';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ContactUsResourceInfo } from '../ContactUsResource/ContactUsResource';
import { ContactUs } from '../interfaces/ContactUs';
import Content from './Content';
import { StyledLinePrompt, StyledTile } from './CustomerServiceTile.styles';

export interface CustomerServiceTileProps { }

const CustomerServiceTile: FC<CustomerServiceTileProps> = () => {
  const { t } = useTranslation('ContactUsPage');
  const contactUs: ContactUs = useScopedSelector(ContactUsResourceInfo.dataDst);
  if (!contactUs || contactUs?.lineOfBusinesses?.length === 0) {
    return null;
  }
  return (
    <StyledTile data-testid="customerServiceTile" titleAs="h2" title={t('customerServiceTitle')}>

      {contactUs?.lineOfBusinesses?.map((lineOfBusiness) => (
        <FormCollapse key={lineOfBusiness.name} title={lineOfBusiness.name} name={lineOfBusiness.name}>
          <div>
            <Content lineOfBusiness={lineOfBusiness} />
            {lineOfBusiness.contacts.filter((contact) => contact.email).length > 0 && <StyledLinePrompt>{t('emailPrompt')}</StyledLinePrompt>}
          </div>
        </FormCollapse>
      ))}
    </StyledTile>

  );
};

export default CustomerServiceTile;
